import { authorizedUser } from "components/Common/commonFunctions";
import * as api from "../API/index";
import { jobList, regionList } from "constants/job";
import { WORK_ORDER } from "components/Common/constants";
import { serviceHistory } from "constants/customer";
import { jobTypeList } from "constants/jobType";
import { quotationList } from "constants/quotation";

export const getJobList = async (
  dispatch,
  { pageNum, filters, searchString } = {},
) => {
  try {
    const res = await api.job_list(pageNum, filters, searchString);
    dispatch({ type: jobList, payload: res.data });
  } catch (error) {
    dispatch({ type: jobList, payload: error?.response?.data || error });
    authorizedUser(error.response?.data);
  }
};

//get user detail by id
export const getJobByID = async (id) => {
  try {
    const res = await api.get_job_by_ID(id);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// get job time line by id
export const getJobTimeLineByID = async (id) => {
  try {
    const res = await api.job_time_line_by_ID(id);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const getTechnicalReportByID = async (id) => {
  try {
    const res = await api.technical_report_by_ID(id);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// Cancel Job By Job id
export const cancelJobByJobId = async (jobId, body) => {
  try {
    const res = await api.cancel_job(jobId, body);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// Job Media
export const getJobMediaByJobID = async (jobId) => {
  try {
    const res = await api.jobMedia(jobId);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// Complete or Rework Job

export const updateJobStatus = async (jobId, bodyData) => {
  try {
    const res = await api.jobCompletedOrRework(jobId, bodyData);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// Download Job Report
export const downloadJobReportByJobId = async (jobId) => {
  try {
    const res = await api.downloadJobReport(jobId);
    return res;
  } catch (error) {
    if (error.response && error.response.data instanceof Blob) {
      const text = await error.response.data.text();
      try {
        const parsed = JSON.parse(text);
        return {
          status: error.response.status,
          code: parsed.code,
          message: parsed.message,
        };
      } catch {
        return {
          status: error.response.status,
          code: 500,
          message: `Failed to download ${WORK_ORDER} report. Please try again.`,
        };
      }
    }

    return {
      status: 500,
      code: 500,
      message:
        error.message || `Failed to download ${WORK_ORDER} report. Please try again.`,
    };
  }
};

export const downloadJobMedia = async (jobMediaID, technicalReportID = 0) => {
  try {
    const res = await api.download_job_media(jobMediaID, technicalReportID);
    return res;
  } catch (error) {
    if (error.response && error.response.data instanceof Blob) {
      const text = await error.response.data.text();
      const json = JSON.parse(text);
      return json;
    }

    return (
      error.response?.data || {
        code: 500,
        status: "FAILED",
        message: `Failed to download ${WORK_ORDER} media. Please try again.`,
      }
    );
  }
};

export const getRegionList = async (dispatch) => {
  try {
    const res = await api.region_list();
    dispatch({ type: regionList, payload: res.data });
  } catch (error) {
    dispatch({ type: regionList, payload: error?.response?.data || error });
    authorizedUser(error.response?.data);
  }
};

export const getServiceList = async (dispatch, equipmentId,) => {
  try {
    const res = await api.getServiceHistory(equipmentId);
    dispatch({ type: serviceHistory, payload: res.data });
  } catch (error) {
    dispatch({
      type: serviceHistory,
      payload: error?.response?.data || error,
    });
    authorizedUser(error.response?.data);
  }
};


export const getEquipmentManual = async (jobId) => {
  try {
    const res = await api.equipmentManual(jobId);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// download equipment invoice
export const downloadEquipmentInvoice = async (equipmentID) => {
  try {
    const res = await api.download_equipment_invoice(equipmentID);
    return res;
  } catch (error) {
    if (error.response && error.response.data instanceof Blob) {
      const text = await error.response.data.text();
      const json = JSON.parse(text);
      return json;
    }

    return (
      error.response?.data || {
        code: 500,
        status: "FAILED",
        message: "Failed to download invoice. Please try again.",
      }
    );
  }
}

//download quotation history
export const downloadQuotationHistory = async (quotationId) => {
  try {
    const res = await api.download_quotation_by_ID(quotationId);
    return res;
  } catch (error) {
    authorizedUser(error.response?.data);
    if (error.response && error.response.data instanceof Blob) {
      const text = await error.response.data.text();
      try {
        const parsed = JSON.parse(text);
        return {
          status: error.response.status,
          code: parsed.code,
          message: parsed.message,
        };
      } catch {
        return {
          status: error.response.status,
          code: 500,
          message: "Failed to download quotation. Please try again.",
        };
      }
    }
  }
};

// Get job type list
export const getJobTypeList = async (dispatch, { pageNum, filters } = {}) => {
  try {
    const res = await api.job_type_list(pageNum, filters);
    dispatch({ type: jobTypeList, payload: res.data });
  } catch (error) {
    dispatch({ type: jobTypeList, payload: error?.response?.data || error });
    authorizedUser(error.response?.data);
  }
};

// export 
export const downloadProductManual = async (productDocumentID, type) => {
  try {
    const res = await api.download_product_manual(productDocumentID, type)
    return res;
  } catch (error) {
    if (error.response && error.response.data instanceof Blob) {
      const text = await error.response.data.text();
      const json = JSON.parse(text);
      return json;
    }

    return (
      error.response?.data || {
        code: 500,
        status: "FAILED",
        message: "Failed to download product manual. Please try again.",
      }
    );
  }
}

// get quotation details
export const getQuotationDetails = async (dispatch, jobId) => {
  try {
    const res = await api.get_quotation_detail(jobId);
    dispatch({ type: quotationList, payload: res.data });
  } catch (error) {
    dispatch({ type: quotationList, payload: error?.response?.data || error });
    authorizedUser(error.response?.data);
  }
};

// send quotation
export const updateStatusQuotation = async (body) => {
  try {
    const res = await api.update_status_quotation(body);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};